import { useState } from "react";
import EntryMode from "@/pages/dashboard/kpi/EntryMode";
import ScorecardMode from "@/pages/dashboard/kpi/ScorecardMode";
import WallMode from "@/pages/dashboard/kpi/WallMode";

const MODES = [
  { id: "entry",     label: "Entry",     desc: "Per-job checklist entry (Katt's editable layer)" },
  { id: "scorecard", label: "Scorecard", desc: "Weekly rollup per tech with per-KPI compliance" },
  { id: "wall",      label: "Wall",      desc: "Monday meeting TV display" },
];

export default function KpiTracker() {
  const [mode, setMode] = useState("entry");
  return (
    <div data-testid="kpi-page" className="space-y-5">
      <header>
        <div className="text-[11px] uppercase tracking-[.15em] text-[color:var(--cc-ink-muted)] font-semibold">
          North star — OBP
        </div>
        <h1 className="font-display font-bold text-[26px] sm:text-[32px] tracking-tight text-[#0e1420] mt-1">KPI Tracker</h1>
        <p className="text-[13.5px] text-[color:var(--cc-ink-muted)] mt-1">
          Synced from ServiceTitan + Rilla. Same numbers for every operating unit.
        </p>
      </header>

      <div className="inline-flex bg-white border border-[#e7e9ee] rounded-xl p-1" data-testid="kpi-mode-switch">
        {MODES.map((m) => (
          <button
            key={m.id}
            onClick={() => setMode(m.id)}
            data-testid={`kpi-mode-${m.id}`}
            className={`px-4 py-2 text-[12.5px] rounded-lg font-semibold transition-colors ${
              mode === m.id
                ? "bg-[#0072bc] text-white"
                : "text-[color:var(--cc-ink-muted)] hover:bg-[#f5f6f8]"
            }`}
          >
            {m.label}
          </button>
        ))}
      </div>
      <div className="text-[12px] text-[color:var(--cc-ink-muted)] -mt-2">
        {MODES.find((m) => m.id === mode).desc}
      </div>

      {mode === "entry" && <EntryMode />}
      {mode === "scorecard" && <ScorecardMode />}
      {mode === "wall" && <WallMode />}
    </div>
  );
}
